/* global axios */
import ApiClient from '../ApiClient';

class AiAssistMessagesAPI extends ApiClient {
  constructor() {
    super('ai_assist/threads', { accountScoped: true });
  }

  get(threadId) {
    return axios.get(`${this.url}/${threadId}/messages`);
  }

  create({ threadId, ...payload }) {
    return axios.post(`${this.url}/${threadId}/messages`, payload);
  }
}

export default new AiAssistMessagesAPI();
